<template>
  <div class="container">
    <div class="action-part">
      <el-form :inline="true" size="medium">
        <el-form-item>
          <el-button type="primary" @click="showEditor(null)">创建配置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="content-list">
      <el-table
          :data="resultList"
          style="width: 100%;margin-bottom: 20px;"
          row-key="id"
          border
          :default-expand-all="false"
          :tree-props="{children: 'children'}">

        <el-table-column
            prop="id"
            label="主键ID"
            sortable
            width="250">
        </el-table-column>

        <el-table-column
            prop="name"
            label="模块名"
            sortable
            width="350">
        </el-table-column>
        <el-table-column
            align="center"
            prop="backgroundImage"
            label="图标"
            width="300">
          <template v-slot="scope">
            <el-image style="width: 200px; height: 100px" :src="scope.row.backgroundImage" fit="contain" v-if="scope.row.backgroundImage"></el-image>
            <div v-else>暂无图片</div>
          </template>
        </el-table-column>
        <el-table-column
            prop="description"
            label="模块描述">
        </el-table-column>
        <el-table-column
            prop="dev"
            label="是否开发中"
            width="200">
        </el-table-column>
        <el-table-column
            prop="display"
            label="是否显示"
            width="200">
        </el-table-column>
        <el-table-column
            prop="sorted"
            label="从小到大排序"
            width="200">
        </el-table-column>
        <el-table-column
            width="250"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="medium" @click="showEditor(scope.row)">编辑</el-button>
            <el-popconfirm
                confirm-button-text='马上删除'
                cancel-button-text='我后悔了'
                icon="el-icon-info"
                @confirm="deleteItem(scope.row)"
                icon-color="red"
                title="确定删除该游戏配置吗？">
              <el-button slot="reference" type="danger" style="margin-left: 10px;" size="medium">
                删除
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="dialog-part">
      <el-dialog
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :title="dialogText"
          center
          :visible.sync="isEditorShow"
          width="500px">
        <div class="editor-content">
          <el-form size="medium" label-width="100px">
            <el-form-item label="配置名" required>
              <el-input v-model="appModule.name" placeholder="请输入配置名称"></el-input>
            </el-form-item>
            <el-form-item label="配置描述">
              <el-input v-model="appModule.description" placeholder="请输入配置描述"></el-input>
            </el-form-item>
            <el-form-item label="选择父级模块">
              <el-cascader
                  clearable
                  v-model="selectParentIds"
                  :options="resultList"
                  :props="{ checkStrictly: true, value: 'id', label: 'name' }"
                  :show-all-levels="false"
                  @change="handleChange"></el-cascader>
            </el-form-item>
            <el-form-item label="是否开发中">
              <el-input v-model="appModule.dev" placeholder="请输入配置描述"></el-input>
            </el-form-item>
            <el-form-item label="是否显示">
              <el-input v-model="appModule.display" placeholder="请输入配置描述"></el-input>
            </el-form-item>
            <el-form-item label="从小到大排序">
              <el-input-number :min="0" v-model="appModule.sorted" placeholder="从小到大排序"></el-input-number>
            </el-form-item>
            <el-form-item label="背景图片" :required="true">
              <div class="form-item-container">
                <el-upload
                    accept="image/jpeg,image/png,image/jpg"
                    :show-file-list="false"
                    action=""
                    :http-request="uploadImage">
                  <div class="video-image-upload-cover image-upload-cover">
                    <img v-if="appModule.backgroundImage" :src="appModule.backgroundImage" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </div>
                </el-upload>
              </div>
              <div class="form-des-text">
                支持JPEG/PNG，不超过2M
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="dialog-action" solt="footer" style="text-align: center">
          <el-button size="medium" @click="onEditorCancel">取 消</el-button>
          <el-button type="primary" size="medium" @click="onEditorConfirm">提 交</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script lang="ts">
import * as api from '@/api/api'

export default {
  name: 'AppModule',
  data() {
    return {
      name: 'AppModule',
      appModule: {
        id: "",
        parentId: "0",
        name: "",
        description: "",
        backgroundImage: "",
        dev: 0,
        display: 0,
        sorted: 100,
      },
      selectParentIds: [],
      resultList: [],
      dialogText: "新增模块配置",
      isEditorShow: false,
    }
  },
  methods: {
    getTreeContent() {
      api.getAppModuleTree().then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.resultList = result.data;
        }
      })
    },
    deleteItem(item) {
      api.deleteAppModule(item.id).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.$message.success(result.msg);
          this.getTreeContent();
        } else {
          this.$message.error(result.msg);
        }
      })
    },

    findPath(tree, targetId, path = []) {
      for (let node of tree) {
        const currentPath = [...path, node.id];
        if (node.id === targetId) {
          return currentPath;
        }
        if (node.children && node.children.length > 0) {
          const result = this.findPath(node.children, targetId, currentPath);
          if (result) return result;
        }
      }
      return null;
    },

    showEditor(item) {
      this.selectParentIds = []
      const setModulePath = () => {
        if (item) {
          this.appModule.id = item.id;
          this.appModule.name = item.name;
          this.appModule.parentId = item.parentId;
          this.appModule.description = item.description;
          this.appModule.backgroundImage = item.backgroundImage;
          this.appModule.dev = item.dev;
          this.appModule.sorted = item.sorted;
          this.appModule.display = item.display;
          let path = this.findPath(this.resultList, item.parentId);
          this.selectParentIds = path || [];
          this.dialogText = '编辑模块配置';
        } else {
          this.dialogText = '创建模块配置';
        }
        this.isEditorShow = true;
      }

      // 如果模块树数据不存在，则先加载
      if (this.resultList.length === 0) {
        api.getAppModuleTree().then((result) => {
          if (result.code === api.SUCCESS_CODE) {
            this.resultList = result.data;
            // 数据加载完成后，再设置模块路径
            setModulePath();
          }
        });
      } else {
        // 如果已有数据，直接设置
        setModulePath();
      }
    },
    uploadImage(object) {
      let formData = new FormData();
      formData.append('image', object.file);
      api.postGameImage(formData).then((result) => {
        if (result.code === api.SUCCESS_CODE) {
          let url = result.data;
          this.$message({
            message: '模块封面上传成功.',
            type: 'success',
            center: true
          });
          this.appModule.backgroundImage = url;
        } else {
          this.$message.error(result.msg);
        }
      }).catch((err) => {
        console.log(err);
        this.$message({
          message: '模块封面出错',
          type: 'error',
          center: true
        })
      })
    },
    onEditorCancel() {
      this.appModule = {
        id: "",
        parentId: "0",
        name: "",
        description: "",
        backgroundImage: "",
        dev: 0,
        display: 0,
        sorted: 100,
      }
      this.isEditorShow = false;
    },
    onEditorConfirm() {
      if (this.appModule.name === '') {
        return this.$message.error("请输入配置项名称.")
      }
      if (this.appModule.backgroundImage === '') {
        return this.$message.error("请上传模块背景图.")
      }
      if (this.selectParentIds[this.selectParentIds.length - 1]) {
        this.appModule.parentId = this.selectParentIds[this.selectParentIds.length - 1]
      }else {
        this.appModule.parentId = "0"
      }
      if (this.appModule.id !== '') {
        api.updateAppModuleById(this.appModule.id, this.appModule).then(result => {
          if (result.code === api.SUCCESS_CODE) {
            this.$message.success(result.msg);
            this.onEditorCancel();
            this.getTreeContent();
            this.appModule = {
              id: "",
              parentId: "0",
              name: "",
              description: "",
              backgroundImage: "",
              dev: 0,
              display: 0,
              sorted: 100,
            }
          } else {
            this.$message.error(result.msg);
          }
        })
      } else {
        api.saveAppModule(this.appModule).then(result => {
          if (result.code === api.SUCCESS_CODE) {
            this.$message.success(result.msg);
            this.onEditorCancel();
            this.getTreeContent();
            this.appModule = {
              id: "",
              parentId: "0",
              name: "",
              description: "",
              backgroundImage: "",
              dev: 0,
              display: 0,
              sorted: 100,
            }
          } else {
            this.$message.error(result.msg);
          }
        })
      }
    },
    handleChange(value) {
      console.log(value);
    }
  },
  mounted() {
    // 处理mp3上传地址，拼接上token信息
    const token = this.$store.state.user.token;
    this.uploadFilePath = api.baseUrl + `/md/file/app?ct-sob-admin-token=${token}`
    this.getTreeContent();
  },
}
</script>

<script lang="ts" setup></script>

<style scoped>
.video-image-upload-cover {
  line-height: 240px;
  width: 240px;
  height: 240px;
}

.image-upload-cover img {
  width: 100%;
  object-fit: cover;
  height: 100%;
}

.image-upload-cover {
  text-align: center;
  cursor: pointer;
  line-height: 100px;;
  margin-right: 20px;
  width: 100px;
  height: 100px;
  border-radius: 4px;
  border: #DCDFE6 dashed 2px;
}
</style>
